export default "__VITE_ASSET__B1QB2yFl__"